import React, { Component } from "react";
import { connect, useDispatch } from "react-redux";
import DatePicker from "react-datepicker";
import CustomDatePickerInput from "../_common/CustomDatePickerInput";
import Select from "react-select";
import AdrTypeSelectorV3 from "./AdrTypeSelectorV3";
import { ADR_EDIT } from "../../_constants/actionConstants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import projCompActions from "../../_actions/projCompActions";
import { getTimeOptions } from "../../_utils/generalUtils";
import AdrAmendmentHistoryV3 from "./AdrAmendmentHistoryV3";
import NwsWeatherFetcher from "./NwsWeatherFetcher";
import memoizeOne from "memoize-one";
import adrActions from "../../_actions/adrActions";

class AdrHeaderV3 extends Component {
  state = {
    reportStartDate: new Date(), // default to today
    reportEndDate: new Date(),
    reportNo: "", // today's reportNo
    reportNoSuffix: "",
    customCategory: "",
    timeOptions: [],
    contractorStartShift: "0630", // new Date(today.setHours(6, 30)),
    contractorEndShift: "1500", // new Date(today.setHours(15, 0)),
    engineerStartShift: "0700", // new Date(today.setHours(7, 0)),
    engineerEndShift: "1530", // new Date(today.setHours(15, 30)),
    engineerOT: 0,
    engineerOTReason: "",
    engineerOnLeave: false,
    weatherCondition: 0,
    highTemp: "",
    lowTemp: "",
    weatherComment: "",
    nonWorkingDay: false,
    isCem4501: false,
  };

  componentDidMount() {
    const { adr } = this.props;
    if (adr) {
      this.setHeaderState();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { adr: updatedAdr } = this.props;
    if (!prevProps.adr && updatedAdr) this.setHeaderState();
  }

  setHeaderState = () => {
    const { adr: adrFromProps, fetchWorkDayNumber, updateHeader } = this.props;
    const header = { ...this.state };
    const adrKeys = Object.keys(adrFromProps);
    adrKeys.forEach((key) => {
      if (key in header) {
        header[key] = adrFromProps[key];
      }
    });

    // Fetch auto-generated reportNo only if adr.reportNo is blank (i.e. when
    // adr isNew). This is to preserve any custom reportNo's entered by users
    // prior to V3 update.
    if (!adrFromProps.reportNo)
      fetchWorkDayNumber(adrFromProps.reportStartDate, true).then((data) => {
        this.setState({ ...data });
        updateHeader({ ...data });
      });

    this.setState({
      ...header,
      timeOptions: getTimeOptions(),
    });
  };

  changeDrType = (isCem4501) => {
    const { markAdrDirty, updateHeader } = this.props;
    this.setState({ isCem4501 }, markAdrDirty);
    updateHeader({ isCem4501 });
  };

  handleChange = (e) =>
    this.setState({ [e.target.name]: e.target.value }, this.props.markAdrDirty);

  handleBlur = (e) => this.props.updateHeader({ [e.target.name]: e.target.value });

  handleChange_time = (targetName) => (selectedTime) => {
    const { markAdrDirty, updateHeader } = this.props;
    this.setState({ [targetName]: selectedTime.value }, markAdrDirty);
    updateHeader({ [targetName]: selectedTime.value });
  };

  handleChange_date = (value) => {
    const { markAdrDirty, fetchWorkDayNumber, updateHeader } = this.props;
    fetchWorkDayNumber(value, true).then((data) => {
      updateHeader({ ...data, reportStartDate: value });
      this.setState({ reportStartDate: value, ...data }, markAdrDirty);
    });
  };

  handleChange_check = (e) => {
    const { markAdrDirty, updateHeader } = this.props;
    this.setState({ [e.target.name]: e.target.checked }, markAdrDirty);
    updateHeader({ [e.target.name]: e.target.checked });
  };

  handleWeatherFetched = ({ highTemp, lowTemp, weatherCondition }) => {
    const { markAdrDirty, updateHeader } = this.props;
    const updates = {};
    if (highTemp !== "") updates.highTemp = highTemp;
    if (lowTemp !== "") updates.lowTemp = lowTemp;
    if (weatherCondition !== null) updates.weatherCondition = weatherCondition;
    if (Object.keys(updates).length) {
      this.setState(updates, markAdrDirty);
      updateHeader(updates);
    }
  };

  memoizedOriginalAdrId = memoizeOne((adr) =>
    adr
      ? adr.isAmendment
        ? adr.originalAssistantDailyReportId
        : adr.assistantDailyReportId
      : null
  );

  render() {
    const { fullEA, adr, status, tabId, amendmentHistory } = this.props;
    const { ...header } = this.state;
    const originalAdrId = this.memoizedOriginalAdrId(adr);
    console.log("adr", adr);
    return (
      <React.Fragment>
        <AdrTypeSelectorV3
          changeDrType={this.changeDrType}
          tabId={tabId}
          selectedDrType={header.isCem4501 ? "cem4501" : "cem4601"}
          isReadOnly={status.isReadOnly}
        />
        <div className="card m-2">
          <div className="card-body">
            {adr && status.isChanged && <AdrModifiedAlert />}
            {adr && adr.isDraft && !adr.isNew && <AdrDraftAlert />}
            {adr && adr.isApproved && <AdrApprovedAlert />}
            {adr && adr.isCopy && <AdrCopyAlert />}
            {adr && adr.isSubmitted && status.userIsAuthor && !adr.isInReview && (
              <AdrRetractableAlert
                adrId={adr.assistantDailyReportId}
                submittedOn={adr.submittedOn}
              />
            )}
            {adr && adr.isSubmitted && adr.isInReview && status.userIsReviewer && (
              <AdrReviewerAlert />
            )}
            {amendmentHistory &&
              (adr.isAmendment || (amendmentHistory || []).length > 1) && (
                <AdrAmendmentHistoryV3 tabId={tabId} originalAdrId={originalAdrId} />
              )}
            <div className="row mt-2">
              <div className="col-lg">
                <div className="form-group row">
                  <label className="col-4 col-form-label">
                    <b>EA:</b>
                  </label>
                  <div className="col-8">
                    <input
                      type="text"
                      name="projectEA"
                      id="projectEA"
                      value={fullEA || ""}
                      onChange={this.handleChange}
                      className="form-control"
                      disabled
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="ReportNo" className="col-4 col-form-label">
                    <b>Report No:</b>
                  </label>
                  <div className="col-5 pr-1">
                    <input
                      type="text"
                      name="reportNo"
                      id="reportNo"
                      value={header.reportNo || ""}
                      className="form-control"
                      //onChange={this.handleChange}
                      //onBlur={this.handleBlur}
                      disabled={true}
                    />
                  </div>
                  <div className="col-3 pl-0">
                    <input
                      type="text"
                      name="reportNoSuffix"
                      id="reportNoSuffix"
                      value={header.reportNoSuffix || ""}
                      className="form-control"
                      //onChange={this.handleChange}
                      //onBlur={this.handleBlur}
                      maxLength="1"
                      placeholder="(Suffix)"
                      disabled={true}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="ReportStartDate" className="col-4 col-form-label">
                    <b>Report Date:</b>
                  </label>
                  <div className="col-8 ml-auto">
                    <DatePicker
                      customInput={<CustomDatePickerInput />}
                      name="reportStartDate"
                      id="reportStartDate"
                      selected={header.reportStartDate}
                      dateFormat="MM/dd/yyyy (E)"
                      onChange={this.handleChange_date}
                      disabled={status.isReadOnly}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="customCategory" className="col-4 col-form-label">
                    Subcat:
                  </label>
                  <div className="col-8 ml-auto">
                    <input
                      type="text"
                      name="customCategory"
                      id="customCategory"
                      className="form-control"
                      maxLength="10"
                      value={header.customCategory || ""}
                      onChange={this.handleChange}
                      onBlur={this.handleBlur}
                      disabled={status.isReadOnly}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col-4" />
                  <div className="col-8 ml-auto">
                    <div className="custom-control-inline custom-control custom-checkbox">
                      <input
                        type="checkbox"
                        name="nonWorkingDay"
                        id="nonWorkingDay"
                        className="custom-control-input my-auto"
                        value={header.nonWorkingDay}
                        checked={header.nonWorkingDay}
                        onChange={this.handleChange_check}
                        disabled={status.isReadOnly || !status.userIsReviewer}
                      />
                      <label
                        htmlFor="nonWorkingDay"
                        className="custom-control-label my-auto"
                      >
                        Non-working Day
                      </label>
                    </div>
                    <small>(Determined by RE)</small>
                  </div>
                </div>
              </div>
              <div className="col-lg">
                <table className="table table-borderless mb-0">
                  <thead>
                    <tr className="d-flex">
                      <td className="col-4 td-nopadding">&nbsp;</td>
                      <td className="col-4 td-nopadding">
                        <b>Begin Shift:</b>
                      </td>
                      <td className="col-4 td-nopadding">
                        <b>End Shift:</b>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="d-flex">
                      <td className="col-4 td-nopadding">
                        <b>Contractor:</b>
                      </td>
                      <td className="col-4 td-nopadding">
                        <Select
                          name="contractorStartShift"
                          id="contractorStartShift"
                          options={header.timeOptions}
                          value={
                            adr && adr.engineerOnLeave
                              ? null
                              : header.timeOptions.find(
                                  (t) => t.value === header.contractorStartShift
                                )
                          }
                          onChange={this.handleChange_time("contractorStartShift")}
                          isDisabled={status.isReadOnly || adr.engineerOnLeave}
                          isSearchable={false}
                          styles={{
                            // Fixes the overlapping problem of the component
                            menu: (provided) => ({ ...provided, zIndex: 9999 }),
                          }}
                        />
                      </td>
                      <td className="col-4 td-nopadding">
                        <Select
                          name="contractorEndShift"
                          id="contractorEndShift"
                          options={header.timeOptions}
                          value={
                            adr && adr.engineerOnLeave
                              ? null
                              : header.timeOptions.find(
                                  (t) => t.value === header.contractorEndShift
                                )
                          }
                          onChange={this.handleChange_time("contractorEndShift")}
                          isDisabled={status.isReadOnly || adr.engineerOnLeave}
                          isSearchable={false}
                          styles={{
                            // Fixes the overlapping problem of the component
                            menu: (provided) => ({ ...provided, zIndex: 9999 }),
                          }}
                        />
                      </td>
                    </tr>
                    <tr className="d-flex">
                      <td className="col-4 td-nopadding">
                        <b>Engineer:</b>
                      </td>
                      <td className="col-4 td-nopadding">
                        <Select
                          name="engineerStartShift"
                          id="engineerStartShift"
                          options={header.timeOptions}
                          value={
                            adr && adr.engineerOnLeave
                              ? null
                              : header.timeOptions.find(
                                  (t) => t.value === header.engineerStartShift
                                )
                          }
                          onChange={this.handleChange_time("engineerStartShift")}
                          isDisabled={status.isReadOnly || adr.engineerOnLeave}
                          isSearchable={false}
                          styles={{
                            // Fixes the overlapping problem of the component
                            menu: (provided) => ({ ...provided, zIndex: 9999 }),
                          }}
                        />
                      </td>
                      <td className="col-4 td-nopadding">
                        <Select
                          name="engineerEndShift"
                          id="engineerEndShift"
                          options={header.timeOptions}
                          value={
                            adr && adr.engineerOnLeave
                              ? null
                              : header.timeOptions.find(
                                  (t) => t.value === header.engineerEndShift
                                )
                          }
                          onChange={this.handleChange_time("engineerEndShift")}
                          isDisabled={status.isReadOnly || adr.engineerOnLeave}
                          isSearchable={false}
                          styles={{
                            // Fixes the overlapping problem of the component
                            menu: (provided) => ({ ...provided, zIndex: 9999 }),
                          }}
                        />
                      </td>
                    </tr>
                    <tr className="d-flex">
                      <td className="col-4 td-nopadding">Engineer OT:</td>
                      <td className="col-4 td-nopadding">
                        <input
                          type="number"
                          name="engineerOT"
                          id="engineerOT"
                          className="form-control"
                          value={header.engineerOT || ""}
                          onChange={this.handleChange}
                          onBlur={this.handleBlur}
                          disabled={status.isReadOnly || adr.engineerOnLeave}
                        />
                      </td>
                      <td className="col-4 td-nopadding my-auto">hrs</td>
                    </tr>
                    <tr className="d-flex">
                      <td className="col-4 td-nopadding">OT Reason:</td>
                      <td className="col-8 td-nopadding" colSpan="2">
                        <input
                          type="text"
                          name="engineerOTReason"
                          id="engineerOTReason"
                          value={header.engineerOTReason || ""}
                          className="form-control"
                          onChange={this.handleChange}
                          onBlur={this.handleBlur}
                          disabled={status.isReadOnly || adr.engineerOnLeave}
                        />
                      </td>
                    </tr>
                    <tr className="d-flex">
                      <td className="col-4 td-nopadding" />
                      <td className="col-8 td-nopadding" colSpan="2">
                        <div className="custom-control-inline custom-control custom-checkbox">
                          <input
                            type="checkbox"
                            name="engineerOnLeave"
                            id="engineerOnLeave"
                            className="custom-control-input my-auto"
                            value={header.engineerOnLeave}
                            checked={header.engineerOnLeave}
                            onChange={this.handleChange_check}
                            disabled={status.isReadOnly}
                          />
                          <label
                            htmlFor="engineerOnLeave"
                            className="custom-control-label my-auto"
                          >
                            Engineer on Leave
                          </label>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="col-lg">
                <div className="form-group row">
                  <div className="col-sm-4" />
                  <div className="col-sm-8">
                    <NwsWeatherFetcher
                      reportDate={header.reportStartDate}
                      onWeatherFetched={this.handleWeatherFetched}
                      disabled={status.isReadOnly}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="weatherCondition" className="col-sm-4 col-form-label">
                    <b>Weather:</b>
                  </label>
                  <div className="col-sm-8">
                    <select
                      name="weatherCondition"
                      id="weatherCondition"
                      value={header.weatherCondition}
                      className="form-control"
                      onChange={this.handleChange}
                      onBlur={this.handleBlur}
                      disabled={status.isReadOnly}
                    >
                      <option value={-1}>Select Weather...</option>
                      <option value={0}>Clear</option>
                      <option value={1}>Overcast</option>
                      <option value={2}>Foggy</option>
                      <option value={3}>Rain</option>
                      <option value={4}>Snow</option>
                    </select>
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="temp" className="col-sm-4 col-form-label">
                    <b>Temp:</b>
                  </label>
                  <div className="col">
                    <input
                      type="number"
                      name="lowTemp"
                      id="lowTemp"
                      value={header.lowTemp || ""}
                      className="form-control"
                      placeholder="Low"
                      onChange={this.handleChange}
                      onBlur={this.handleBlur}
                      disabled={status.isReadOnly}
                    />
                  </div>
                  <div className="col">
                    <input
                      type="number"
                      name="highTemp"
                      id="highTemp"
                      value={header.highTemp || ""}
                      className="form-control"
                      placeholder="High"
                      onChange={this.handleChange}
                      onBlur={this.handleBlur}
                      disabled={status.isReadOnly}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="weatherComment"
                    className="col-sm-4 col-form-label pr-0"
                  >
                    Weather Comments:
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      name="weatherComment"
                      id="weatherComment"
                      value={header.weatherComment || ""}
                      className="form-control"
                      placeholder="Comments on weather..."
                      onChange={this.handleChange}
                      onBlur={this.handleBlur}
                      disabled={status.isReadOnly}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="writtenBy" className="col-sm-4 col-form-label">
                    <b>Written By:</b>
                  </label>
                  <div className="col-sm-8">
                    <input
                      type="text"
                      name="writtenBy"
                      id="writtenBy"
                      className="form-control"
                      value={adr?.authorFullName || ""} // Auto-populate with the user's name
                      disabled // Make the field read-only
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const AdrModifiedAlert = () => {
  return (
    <div className="alert alert-warning my-1 p-2" role="alert">
      <FontAwesomeIcon className="mr-2" icon="exclamation-triangle" />
      This Daily Report has been modified. Please remember to save before closing.
    </div>
  );
};

const AdrDraftAlert = () => {
  return (
    <div className="alert alert-warning my-1 p-2" role="alert">
      <FontAwesomeIcon className="mr-2" icon="exclamation-triangle" />
      This is a draft Daily Report. Please remember to submit when you're done.
    </div>
  );
};

const AdrCopyAlert = () => {
  return (
    <div className="alert alert-success my-1 p-2">
      <FontAwesomeIcon className="mr-2" icon="exclamation-triangle" />
      This Daily Report is created with data imported from another diary. Please remember
      to save any changes.
    </div>
  );
};

const AdrApprovedAlert = () => {
  return (
    <div className="alert alert-success my-1 p-2" role="alert">
      <FontAwesomeIcon className="mr-2" icon="exclamation-triangle" />
      You are viewing an accepted Daily Report. If you have reviewer privileges, you may
      add RE/SR Comments.
    </div>
  );
};

const AdrRetractableAlert = ({ adrId, submittedOn }) => {
  const dispatch = useDispatch();

  const handleClick_retract = (e) => {
    e.preventDefault();
    dispatch(adrActions.retractSubmission(adrId));
  };

  return (
    <div className="alert alert-warning my-1 p-2" role="alert">
      <FontAwesomeIcon className="mr-2" icon="info-circle" />
      This Daily Report was submitted for review on{" "}
      {submittedOn ? submittedOn.toLocaleString() : "(Date N/A)"}, but until the reviewer
      starts the review, you can retract submission to make further edits.
      <button
        name="retract"
        id="retract"
        className="btn btn-sm btn-primary ml-2"
        onClick={handleClick_retract}
      >
        <b>Retract Submission</b>
      </button>
    </div>
  );
};

const AdrReviewerAlert = () => {
  return (
    <div className="alert alert-warning my-1 p-2" role="alert">
      <FontAwesomeIcon className="mr-2" icon="info-circle" />
      You are viewing this report as a reviewer. Review comments are enabled, and you may
      accept or reject this report.
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  const workdayNumber =
    state.adr.openAdrs[ownProps.tabId] && state.adr.openAdrs[ownProps.tabId].reportNo;
  const adr = state.adr.openAdrs[ownProps.tabId] || null;

  // originalAdrId is used to look up amendmentHistory in miscSessionData.
  const originalAdrId = adr
    ? adr.isAmendment
      ? adr.originalAssistantDailyReportId
      : adr.assistantDailyReportId
    : null;
  return {
    adr,
    amendmentHistory:
      (originalAdrId && state.adr.miscSessionData.amendmentHistory[originalAdrId]) ||
      null ||
      null,
    reportNo: workdayNumber && workdayNumber,
    reportNoSuffix: workdayNumber && "",
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchWorkDayNumber: (date, isFiveDayWorkingCalendar) =>
      dispatch(
        projCompActions.fetchWorkDayNumber(date, isFiveDayWorkingCalendar, ownProps.tabId)
      ),
    updateHeader: (headerFields) => {
      dispatch({
        type: ADR_EDIT.HEADER.UPDATE,
        tabId: ownProps.tabId,
        headerFields,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdrHeaderV3);
